/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 
$(document).ready(function() {
    // $(".ProductForm2").on("submit",function(event){
    //   event.preventDefault(); // Prevent form to be submitted

    //   var addToCartButton = $(this).find('.ProductForm__AddToCart_best'); // First, we switch the status of the button

    //   document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax

    //   var data = JSON.stringify(theme.Form.serialize($(this))),
    //   fetch("".concat(window.routes.cartAddUrl, ".js"), {
    //     body: data,
    //     credentials: 'same-origin',
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

    //     }
    //   }).then(function (response) {
    //     document.dispatchEvent(new CustomEvent('theme:loading:end'));
    //   });
    //   event.preventDefault();
    // });
    // $(".ProductForm__AddToCart_best").on("click", function() {
    //   datas = {
    //     "id": $(this).closest("form").find(".ColorSwatch__Radio:checked").attr("data-variant-id"),
    //     "quantity": 1
    //   }
    //   console.log(datas);
    //   $.ajax({
    //     type: 'POST',
    //     url: '/cart/add.js',
    //     data: datas,
    //     dataType: 'json',
    //     success: function() { 
    //       console.log('success');
    //       theme.sidebarDrawer.open();
    //       // var drawer = new theme.CartDrawer();          
    //       // return drawer.buildCart;
    //     }
    //   });
    // });
    $(".ProductForm2 .ColorSwatch__Radio").on("change", function() {
      var variant_id = $(this).attr("data-variant-id");
      $(this).closest("form").find(".no-js.ProductForm__Option select option:selected").removeAttr('selected');
      $(this).closest("form").find(".no-js.ProductForm__Option select option[value=" + variant_id + "]").attr('selected', 'selected');
    });
});  